import { useState } from "react";
import Select from "../ScpSelect";
import Flow from "./flow";
import Alert from '../Alert';

export default function MateriallFlow({
  onChange = () => { },
  formValue = {},
  t = (s) => s,
  visible = false,
  id,
  focusParticipant,
  setDisabledFooter = () => { },
}) {
  const [disabledIds, setDisabledIds] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <div className="form-group">
      {visible && (
        <Alert
          message="Select the scope of the supply chain anaysis by selecting the focus participant. The supply chain of that focus participant will be automatically loaded based on information available from project sources. You can remove mine sites and suppliers from your analysis."
          localKey="materialFlowProject"
        />
      )}
      <Select
        formValue={formValue}
        value={formValue.focusScp}
        label={t('Focus Participant')}
        placeholder={t('Select a focus supply chain actor')}
        focusParticipant={focusParticipant}
        id={id}
        onChange={(v) => {
          onChange('focusScp', v);
          setDisabledIds([]);
        }}
        onClear={() => {
          onChange('focusScp', undefined);
          onChange('selectedScp', []);
          setDisabledIds([]);
        }}
        disabled={loading}
      />
      {!!formValue.focusScp && (
        <Flow
          loading={loading}
          setLoading={setLoading}
          focusScp={formValue.focusScp.value}
          disabledIds={disabledIds}
          setDisabledIds={setDisabledIds}
          setDisabledFooter={setDisabledFooter}
          onChange={(v) => onChange('selectedScp', v)}
          value={formValue.selectedScp}
          formValue={formValue}
          onChangeValue={onChange}
        />
      )}
    </div>
  );
}
